const translations = {
  "en": {
    "Free": "Free",
    "money check-up": "money check-up"
  },
  "zh-tw": {
    "Free": "免費",
    "money check-up": "財務健檢"
  }
};

export default translations;
